import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files for each language
import enTranslations from './locales/en.json';
import zhTranslations from './locales/zh.json';
import idTranslations from './locales/id.json';
import filTranslations from './locales/fil.json';

// Passes i18n instance to react-i18next
// Detects user language from browser
i18n?.use(LanguageDetector)?.use(initReactI18next)?.init({
    resources: {
      en: { translation: enTranslations },
      zh: { translation: zhTranslations },
      id: { translation: idTranslations },
      fil: { translation: filTranslations }
    },
    fallbackLng: 'en',  // Use English if requested language unavailable
    interpolation: {
      escapeValue: false  // React already protects from XSS
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;